"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCardSpins = void 0;
var _react = require("react");
const useCardSpins = ({
  gridNumOfColumns,
  selectedSpinIndex,
  setSelectedSpinIndex
}) => {
  const [selectedDetailIndex, setSelectedDetailIndex] = (0, _react.useState)(-1);
  const isRightSpinSelected = (0, _react.useMemo)(() => (selectedSpinIndex + 1) % gridNumOfColumns === 0, [selectedSpinIndex, gridNumOfColumns]);
  const isLeftSpinSelected = (0, _react.useMemo)(() => selectedSpinIndex % gridNumOfColumns === 0, [selectedSpinIndex, gridNumOfColumns]);
  const onCardSpinClick = clickedIndex => {
    if (selectedSpinIndex === clickedIndex) {
      setSelectedSpinIndex(-1);
      setSelectedDetailIndex(-1);
      return;
    }
    setSelectedSpinIndex(clickedIndex);
    setSelectedDetailIndex(Math.floor(clickedIndex / gridNumOfColumns) + 1);
  };
  return {
    selectedDetailIndex,
    isRightSpinSelected,
    isLeftSpinSelected,
    setSelectedDetailIndex,
    onCardSpinClick
  };
};
exports.useCardSpins = useCardSpins;